export enum IpInfoCountry {
  NG = "NG",
  US = "US",
}

export interface IpInfo {
  ip: string;
  city: string;
  region: string;
  country: IpInfoCountry;
  loc: string;
  org: string;
  timezone: string;
}
